/* eslint-disable react/prop-types */
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArgonButton from "components/ArgonButton";

const ProposalPlanTableData = (proposals, handleEditClick, handleDeleteClick) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "title", align: "left" },
    { name: "duration", align: "center" },
    { name: "months", align: "center" },
    { name: "discountPercentage", align: "center" },
    { name: "description", align: "left" },
    { name: "isRecommended", align: "center" },
    { name: "isPremium", align: "center" },
    { name: "benefits", align: "left" },
    { name: "action", align: "center" },
  ],

  rows: proposals.map((proposal, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {index + 1}
      </ArgonTypography>
    ),
    title: (
      <ArgonTypography variant="caption" color="text" fontWeight="bold">
        {proposal.title}
      </ArgonTypography>
    ),
    duration: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {proposal.duration}
      </ArgonTypography>
    ),
    months: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {proposal.months}
      </ArgonTypography>
    ),
    discountPercentage: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {proposal.discountPercentage}%
      </ArgonTypography>
    ),
    description: (
      <ArgonBox>
        <ArgonTypography variant="caption" color="text">
          {proposal.description?.length > 50
            ? `${proposal.description.substring(0, 50)}...`
            : proposal.description}
        </ArgonTypography>
      </ArgonBox>
    ),
    isRecommended: (
      <ArgonBadge
        variant="contained"
        color={proposal.isRecommended ? "success" : "secondary"}
        size="xs"
        badgeContent={proposal.isRecommended ? "Recommended" : "Standard"}
        container
      />
    ),
    isPremium: (
      <ArgonBadge
        variant="contained"
        color={proposal.isPremium ? "warning" : "secondary"}
        size="xs"
        badgeContent={proposal.isPremium ? "Premium" : "Standard"}
        container
      />
    ),
    benefits: (
      <ArgonBox>
        {proposal.benefits?.slice(0, 2).map((benefit, idx) => (
          <ArgonTypography key={idx} variant="caption" color="text" display="block">
            • {benefit}
          </ArgonTypography>
        ))}
        {proposal.benefits?.length > 2 && (
          <ArgonTypography variant="caption" color="secondary">
            +{proposal.benefits.length - 2} more
          </ArgonTypography>
        )}
      </ArgonBox>
    ),
    action: (
      <ArgonBox display="flex" gap={1}>
        <ArgonButton
          variant="text"
          color="info"
          size="medium"
          onClick={() => handleEditClick(proposal)}
        >
          <EditIcon fontSize="large" />
        </ArgonButton>
        <ArgonButton
          variant="text"
          color="error"
          size="medium"
          onClick={() => handleDeleteClick(proposal._id)}
        >
          <DeleteIcon fontSize="large" />
        </ArgonButton>
      </ArgonBox>
    ),
  })),
});

export default ProposalPlanTableData;
